var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c("van-icon", {
        attrs: { name: "ellipsis", size: "20" },
        on: { click: _vm.opTicket }
      }),
      _vm._v(" "),
      _c(
        "van-overlay",
        {
          attrs: { show: _vm.menuShow, "class-name": "menu_overlay" },
          on: { click: _vm.hide }
        },
        [
          _vm.menuShow
            ? _c(
                "div",
                { staticClass: "menu_1" },
                _vm._l(_vm.itemList, function(e) {
                  return _c("div", { key: e, staticClass: "menu_item" }, [
                    _vm._v(_vm._s(e))
                  ])
                }),
                0
              )
            : _vm._e()
        ]
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-15ecfc34", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-15ecfc34","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/mobile-ticket/MobileTicketDetailMenu.vue
// module id = 622
// module chunks = 75